import { AbstractGdprEmbed } from './abstract-gdpr-embed';
import { Modal } from '../utils/modal';

export class ModalGdprManager extends AbstractGdprEmbed {
    constructor(container, userOptions = {}, gtm, eventProxy) {
        super(container, userOptions, gtm, eventProxy);

        this.onModalOpenerClicked = this.onModalOpenerClicked.bind(this);
        this.url = 'none';
    }

    getContainer(container) {
        this.trigger = container;
        this.modal = new Modal();
        return this.modal.getContainer();
    }

    getType() {
        return this.trigger.dataset.ghwpUcService;
    }

    async listen() {
        await super.listen();

        this.trigger.addEventListener('click', this.onModalOpenerClicked);
    }

    loadEmbed(direct = false) {
        super.loadEmbed(direct);
        this.modal.hide();
        if (direct) {
            // window.location = window.location;
            window.history.go();
        }
    }

    onModalOpenerClicked() {
        if (!this.hasLoaded) {
            this.modal.show();
        }
    }
}
